(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 99133:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(49692);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 49692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _404; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(9725);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 13 modules
var Page = __webpack_require__(9092);
// EXTERNAL MODULE: ./components/shared/ButtonLink.styled.tsx
var ButtonLink_styled = __webpack_require__(8536);
// EXTERNAL MODULE: ./components/shared/Typography.js
var Typography = __webpack_require__(99655);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/next/dist/client/router.js
var router = __webpack_require__(93642);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
;// CONCATENATED MODULE: ./components/errorPage/ErrorComponent.constants.ts
// Constants.
// -----------------------------------------------------------------------------
var ERROR_STATUS_CODES = (/* unused pure expression or super */ null && ([
    404,
    500
]));
var DEFAULT_ERROR_COMPONENT_HIDE_ERROR = false;

// EXTERNAL MODULE: ./components/errorPage/ErrorComponent.styled.ts
var ErrorComponent_styled = __webpack_require__(25693);
;// CONCATENATED MODULE: ./components/errorPage/ErrorComponent.tsx













var ErrorComponent = function(param) {
    var errorCode = param.errorCode, _hideErrorCode = param.hideErrorCode, hideErrorCode = _hideErrorCode === void 0 ? DEFAULT_ERROR_COMPONENT_HIDE_ERROR : _hideErrorCode;
    // Hooks.
    var t = (0,useI18n/* useI18n */.Q)("errorPage").t;
    var locale = (0,router.useRouter)().locale;
    // Helpers.
    var renderImage = function() {
        return errorCode === 404 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: (0,paths/* getPublicPath */.A)("/images/404/404-center.png"),
            alt: ""
        }) : null;
    };
    // Render
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.ZP, {
        topBarTransparent: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorComponent_styled/* StyledError */.BD, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorComponent_styled/* StyledErrorStars */.lG, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorComponent_styled/* StyledErrorShootingStar */._R, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorComponent_styled/* StyledErrorShootingStar */._R, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorComponent_styled/* StyledErrorShootingStar */._R, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorComponent_styled/* StyledErrorShootingStar */._R, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorComponent_styled/* StyledErrorShootingStar */._R, {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorComponent_styled/* StyledErrorContent */.id, {
                    children: [
                        !hideErrorCode && renderImage(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                            style: {
                                marginTop: hideErrorCode ? "10rem" : "0"
                            },
                            children: t("".concat(errorCode, ".heading"))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: t("".concat(errorCode, ".desc"))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.home */.uu.home, locale),
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink_styled/* default */.C, {
                                variant: "primaryInverse",
                                sizes: "md",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: free_solid_svg_icons/* faHome */.J9Y
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("".concat(errorCode, ".cta"))
                                    })
                                ]
                            })
                        })
                    ]
                }),
                errorCode === 404 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorComponent_styled/* StyledErrorMountains */.a3, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "left",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (0,paths/* getPublicPath */.A)("/images/404/mountain-left.svg"),
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "right",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (0,paths/* getPublicPath */.A)("/images/404/mountain-right.svg"),
                                alt: ""
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var errorPage_ErrorComponent = (ErrorComponent);

// EXTERNAL MODULE: ./components/shared/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(73412);
;// CONCATENATED MODULE: ./pages/404.tsx




var ErrorPage = function() {
    var t = (0,useI18n/* useI18n */.Q)("errorPage").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                title: t("404.title"),
                desc: t("404.heading")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(errorPage_ErrorComponent, {
                errorCode: 404
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _404 = (ErrorPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,9161,9092,6682,9774,2888,179], function() { return __webpack_exec__(99133); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);